/* Eversill offer engine, v2.
   - selection can never lock up, availability from Liquid is ignored on purpose
   - each tier card carries its own quantity list, 1 to 3
   - per bowl price computed from the tier's bowl count
   - a scarcity strip is injected where the countdown used to be
   - PREVIEW prices are used only when no matching variant exists yet. Real variants always win. */
(function(){
  if(window.__evOffer) return; window.__evOffer=true;

  var FIT_DEFAULT={
    'small':'Size is appropriate for small dogs and cats.',
    'medium':'Size is appropriate for medium dogs.'
  };
  var QTY_MAX=3;
  var ALERT_TEXT='Last units before our next production run';

  var PREVIEW={
    'single|small':         {price:'$34.99', cmp:'$49.99'},
    'single|medium':        {price:'$39.99', cmp:'$54.99'},
    'food and water|small': {price:'$54.99', cmp:'$99.99'},
    'food and water|medium':{price:'$59.99', cmp:'$109.99'}
  };

  function n(x){ return (x===null||typeof x==='undefined')?'':String(x).trim().toLowerCase(); }
  function arr(x){ return [].slice.call(x); }

  function num(str){
    if(!str) return NaN;
    var m=String(str).match(/[0-9][0-9\\u00a0 .,]*[0-9]|[0-9]/);
    if(!m) return NaN;
    var body=m[0].replace(/[\\u00a0 ]/g,'');
    var dot=body.lastIndexOf('.'), com=body.lastIndexOf(',');
    var sep=dot>com?'.':(com>-1?',':'');
    if(sep){
      var cut=body.lastIndexOf(sep);
      return parseFloat(body.slice(0,cut).replace(/[.,]/g,'')+'.'+body.slice(cut+1));
    }
    return parseFloat(body.replace(/[.,]/g,''));
  }

  function money(str,mult){
    if(!str) return str;
    var m=String(str).match(/[0-9][0-9\\u00a0 .,]*[0-9]|[0-9]/);
    if(!m) return str;
    var v=num(str);
    if(isNaN(v)) return str;
    var out=(v*mult).toFixed(2);
    if(m[0].lastIndexOf(',')>m[0].lastIndexOf('.')) out=out.replace('.',',');
    return String(str).replace(m[0],out);
  }

  function divide(str,by){
    if(!str||!by||by<1) return str;
    return money(str, 1/by);
  }

  function boot(){
    var el=document.getElementById('ev-data'); if(!el) return false;
    var data; try{ data=JSON.parse(el.textContent); }catch(e){ return false; }
    if(!data||!data.length) return false;

    var tiersWrap=document.querySelector('.ev-tiers');
    var tiers=arr(document.querySelectorAll('.ev-tier'));
    if(!tiers.length) return false;
    var sizeBtns=arr(document.querySelectorAll('.ev-size'));
    var rail=document.querySelector('.ev-shots');
    var dotwrap=document.querySelector('.ev-shots__dots');
    var shots=rail?arr(rail.querySelectorAll('.ev-shots__s')):[];
    var dots=dotwrap?arr(dotwrap.children):[];
    var vid=document.getElementById('ev-vid');
    var btnp=document.getElementById('ev-btnp');
    var add=document.getElementById('ev-add');
    var fitEl=document.querySelector('.ev-offerx__fit');
    var qtyInput=document.querySelector('#ev-form [name=quantity]');

    var fitParts=null;
    if(fitEl){
      var raw=(fitEl.textContent||'').trim();
      if(raw.indexOf('|')>-1){ fitParts=raw.split('|').map(function(s){ return s.trim(); }); }
      else if(raw){ fitParts=[raw]; }
    }

    var swap=false;
    var wanted=n(tiers[0].getAttribute('data-b'));
    var inB=false,inS=false,i;
    for(i=0;i<data.length;i++){ if(n(data[i].b)===wanted) inB=true; if(n(data[i].s)===wanted) inS=true; }
    if(!inB&&inS) swap=true;
    function gb(d){ return n(swap?d.s:d.b); }
    function gs(d){ return n(swap?d.b:d.s); }

    var hasSize=false;
    for(i=0;i<data.length;i++){ if(gs(data[i])!==''){ hasSize=true; break; } }
    hasSize=hasSize&&sizeBtns.length>0;

    function uniq(fn){
      var out=[],seen={},v;
      for(var k=0;k<data.length;k++){ v=fn(data[k]); if(v!==''&&!seen[v]){ seen[v]=1; out.push(v); } }
      return out;
    }
    var packVals=uniq(gb), sizeVals=uniq(gs);

    function lookup(bv,sv){
      for(var k=0;k<data.length;k++){
        if(gb(data[k])!==bv) continue;
        if(hasSize&&sv!==null&&gs(data[k])!==sv) continue;
        return data[k];
      }
      return null;
    }

    var bi=0, si=0, qty=1;

    function sizeLabel(){ return hasSize?n(sizeBtns[si].getAttribute('data-s')):''; }

    function resolve(x,y){
      var bv=n(tiers[x].getAttribute('data-b'));
      var sv=hasSize?n(sizeBtns[y].getAttribute('data-s')):null;
      var v=lookup(bv,sv); if(v) return v;
      if(packVals.length===tiers.length){
        v=lookup(packVals[x], hasSize?sv:null); if(v) return v;
        if(hasSize&&sizeVals.length===sizeBtns.length){ v=lookup(packVals[x], sizeVals[y]); if(v) return v; }
      }
      v=lookup(bv,null); if(v) return v;
      var p=PREVIEW[bv+'|'+(sv||'')];
      if(p){
        var a=num(p.price), b=num(p.cmp);
        return {id:null, price:p.price, cmp:p.cmp, av:true, off:(b>a?Math.round((b-a)/b*100):0), preview:true};
      }
      return null;
    }

    /* a card is a <button>; a list inside a button is unreliable, so demote it to a div */
    function demote(t){
      if(t.tagName!=='BUTTON') return t;
      var d=document.createElement('div');
      d.className=t.className;
      d.setAttribute('role','button');
      d.setAttribute('tabindex','0');
      if(t.hasAttribute('data-b')) d.setAttribute('data-b',t.getAttribute('data-b'));
      if(t.hasAttribute('data-bowls')) d.setAttribute('data-bowls',t.getAttribute('data-bowls'));
      d.innerHTML=t.innerHTML;
      t.parentNode.replaceChild(d,t);
      return d;
    }
    tiers=tiers.map(demote);
    tiers.forEach(function(t){ if(t.querySelector('.ev-tier__badge')) t.classList.add('ev-hasbadge'); });

    /* the badged card leads */
    if(tiersWrap){
      for(i=0;i<tiers.length;i++){
        if(tiers[i].classList.contains('ev-hasbadge') && i>0){
          tiersWrap.insertBefore(tiers[i], tiers[0]);
          tiers=arr(document.querySelectorAll('.ev-tier'));
          break;
        }
      }
    }
    for(i=0;i<tiers.length;i++){ if(tiers[i].classList.contains('ev-hasbadge')){ bi=i; break; } }

    (function buildAlert(){
      if(!ALERT_TEXT) return;
      var anchor=document.querySelector('.ev-strip')
              || document.querySelector('.ev-offerx__pick--sm')
              || document.querySelector('.ev-sizes')
              || document.querySelector('.ev-tiers');
      if(!anchor||!anchor.parentNode) return;
      var box=document.createElement('div');
      box.className='ev-alert';
      var dot=document.createElement('span');
      dot.className='ev-alert__d'; dot.setAttribute('aria-hidden','true');
      var tx=document.createElement('span');
      tx.textContent=ALERT_TEXT;
      box.appendChild(dot); box.appendChild(tx);
      anchor.parentNode.insertBefore(box,anchor);
      if(anchor.classList.contains('ev-strip')) anchor.parentNode.removeChild(anchor);
    })();

    var sels=[];
    tiers.forEach(function(t){
      var host=t.querySelector('.ev-tier__price');
      if(!host) return;
      var box=document.createElement('span');
      box.className='ev-qbox';
      var cap=document.createElement('span');
      cap.className='ev-qcap'; cap.textContent='Qty';
      var sel=document.createElement('select');
      sel.className='ev-qsel';
      sel.setAttribute('aria-label','How many sets');
      for(var k=1;k<=QTY_MAX;k++){
        var o=document.createElement('option');
        o.value=String(k); o.textContent=String(k);
        sel.appendChild(o);
      }
      box.appendChild(cap); box.appendChild(sel);
      host.appendChild(box);
      sels.push(sel);
      sel.addEventListener('click',function(e){ e.stopPropagation(); });
      sel.addEventListener('change',function(e){
        e.stopPropagation();
        qty=parseInt(sel.value,10)||1;
        var idx=tiers.indexOf(t);
        if(idx>-1) bi=idx;
        render();
      });
    });

    function clearOff(){
      tiers.forEach(function(t){ t.classList.remove('is-off'); });
      sizeBtns.forEach(function(s){ s.classList.remove('is-off'); });
      if(add){ add.disabled=false; add.removeAttribute('disabled'); }
    }

    function paintShots(){
      if(!shots.length) return;
      var lbl=sizeLabel(), shown=0;
      shots.forEach(function(s,k){
        var tag=n(s.getAttribute('data-s'));
        var on=!hasSize||tag===''||tag===lbl;
        s.hidden=!on;
        if(dots[k]) dots[k].hidden=!on;
        if(on) shown++;
      });
      if(dotwrap) dotwrap.hidden=shown<2;
      if(rail) rail.scrollLeft=0;
    }

    function paintThumbs(){
      tiers.forEach(function(t){
        var imgs=arr(t.querySelectorAll('.ev-tier__thumb [data-i]'));
        if(!imgs.length) return;
        var pick=null;
        for(var k=0;k<imgs.length;k++){ if(parseInt(imgs[k].getAttribute('data-i'),10)===si){ pick=imgs[k]; break; } }
        if(!pick) pick=imgs[0];
        imgs.forEach(function(im){ im.hidden=(im!==pick); });
      });
    }

    function paintFit(){
      if(!fitEl||!hasSize) return;
      var lbl=sizeLabel(), txt=null;
      if(fitParts&&fitParts.length>si&&fitParts[si]) txt=fitParts[si];
      if(!txt&&FIT_DEFAULT[lbl]) txt=FIT_DEFAULT[lbl];
      if(!txt&&fitParts&&fitParts[0]) txt=fitParts[0];
      if(!txt) return;
      var paw=document.createElement('span');
      paw.className='ev-paw'; paw.setAttribute('aria-hidden','true');
      fitEl.textContent='';
      fitEl.appendChild(paw);
      fitEl.appendChild(document.createTextNode(' '+txt));
    }

    function render(){
      sizeBtns.forEach(function(s,k){ s.classList.toggle('is-on',k===si); });
      tiers.forEach(function(t,k){
        var v=resolve(k,si);
        t.classList.toggle('is-on',k===bi);
        var q=t.querySelector('[data-now]'), w=t.querySelector('[data-was]'),
            o=t.querySelector('[data-off]'), u=t.querySelector('[data-unit]');
        if(q) q.textContent=v?v.price:'';
        if(w) w.textContent=(v&&v.cmp)?v.cmp:'';
        if(o) o.textContent=(v&&v.off>0)?('Save '+v.off+'%'):'';
        if(u){
          var bowls=parseInt(t.getAttribute('data-bowls'),10)||1;
          u.innerHTML = v ? ('<b>'+divide(v.price,bowls)+'</b> per bowl') : '';
        }
      });
      sels.forEach(function(s){ if(s.value!==String(qty)) s.value=String(qty); });
      clearOff();
      paintShots(); paintThumbs(); paintFit();
      var cur=resolve(bi,si)||data[0];
      if(vid&&cur.id) vid.value=cur.id;
      if(qtyInput) qtyInput.value=String(qty);
      if(btnp) btnp.textContent=' · '+money(cur.price,qty);
    }

    document.addEventListener('click',function(e){
      if(e.target&&e.target.closest&&e.target.closest('.ev-qsel')) return;
      var t=e.target&&e.target.closest?e.target.closest('.ev-tier, .ev-size'):null;
      if(!t) return;
      e.stopPropagation();
      var k;
      if(t.classList.contains('ev-size')){ k=sizeBtns.indexOf(t); if(k<0) return; si=k; }
      else { k=tiers.indexOf(t); if(k<0) return; bi=k; }
      render();
    },true);

    if(window.MutationObserver){
      var root=document.querySelector('.ev-offerx');
      if(root){
        var busy=false;
        new MutationObserver(function(){
          if(busy) return; busy=true;
          window.requestAnimationFrame(function(){ clearOff(); busy=false; });
        }).observe(root,{subtree:true,attributes:true,attributeFilter:['class','disabled']});
      }
    }

    setTimeout(clearOff,400); setTimeout(clearOff,1500);
    render();
    return true;
  }

  function start(){ if(!boot()){ setTimeout(function(){ boot(); },600); } }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',start); } else { start(); }
})();